import apiUrl from './api';
import { getWithAuth } from '@/lib/httpAdapter';

export interface PricingResponse {
  admin_seat_price: number;
  member_seat_price: number;
  admin_seat_price_annual: number;
  member_seat_price_annual: number;
  error: string;
}

export const getPricing = async (): Promise<PricingResponse> => {
  const response = await getWithAuth(`${apiUrl}billing/getPricing`);

  if (!response.ok) {
    throw new Error(`Failed to fetch pricing: ${response.statusText}`);
  }

  return response.json();
};
